// Loader
document.addEventListener('DOMContentLoaded', function () {

    const loader = document.getElementById('general-loader');

    // ================= SHOW / HIDE =================
    window.showLoader = function (show) {
        if (!loader) return;

        if (show) {
            loader.classList.remove('hidden');
            loader.classList.add('flex');
        } else {
            loader.classList.add('hidden');
            loader.classList.remove('flex');
        }
    };

    // ================= LIVEWIRE =================
    if (window.Livewire) {

        document.addEventListener('livewire:request-start', function () {
            if (navigator.onLine) window.showLoader(true);
        });

        document.addEventListener('livewire:request-end', function () {
            window.showLoader(false);
        });

        document.addEventListener('livewire:request-error', function () {
            window.showLoader(false);
        });
    }

    // ================= AUTO LOADER ON LINK CLICK =================
    document.addEventListener('click', function (e) {
        const el = e.target.closest('a');

        if (el && el.href && !el.target && !el.hasAttribute('download')) {
            window.showLoader(true);
        }
    });

});

// login form validation
function loginForm(config) {
    return {
        mode: config.initialMode,
        show: false,

        validateBeforeSubmit(e) {
            let valid = true;

            const email = document.querySelector('[name="email"]');
            const password = document.querySelector('[name="password"]');
            const pin = document.querySelector('[name="pin"]');

            // reset borders
            email.classList.remove('border-red-500');
            if (password) password.classList.remove('border-red-500');
            if (pin) pin.classList.remove('border-red-500');

            // email check
            if (!email.value || !email.value.includes('@')) {
                email.classList.add('border-red-500');
                valid = false;
            }

            // mode-based validation
            if (this.mode === 'password') {
                if (!password.value || password.value.length < 6) {
                    password.classList.add('border-red-500');
                    valid = false;
                }
            }

            if (this.mode === 'pin') {
                if (!pin.value || pin.value.length !== 6) {
                    pin.classList.add('border-red-500');
                    valid = false;
                }
            }

            if (!valid) {
                e.preventDefault();
                this.shake();
            }
        },

        shake() {
            const form = document.getElementById('LoginForm');
            form.classList.add('animate-shake');
            setTimeout(() => form.classList.remove('animate-shake'), 400);
        }
    }
}

window.loginForm = loginForm;


document.addEventListener('alpine:init', () => {
    Alpine.store('fab', {
        open: false,
    });
});